import { usePublicSettings } from '../settings/queries';

export enum FeatureFlag {
  DISABLE_ROLES_SYNC = 'disable-roles-sync',
  NEW_UPDATE_SCHEDULES = 'new-update-schedules',
  DISABLE_EXTERNAL_REQUESTS = 'disable-external-requests',
}

export function useFeatureFlag(
  flag: FeatureFlag,
  {
    onSuccess,
    enabled = true,
  }: { onSuccess?: (isEnabled: boolean) => void; enabled?: boolean } = {}
) {
  return usePublicSettings<boolean>({
    select: (settings) => settings.Features[flag],
    onSuccess,
    enabled,
  });
}
